import { RouteObject, RoutesMap, RouteString, RouteThunk } from "redux-first-router";
import { composeThunks } from "./compose-thunks";
import { RootState } from "../ducks/reducers";

export type RoutesMapWithLazyThunk<TKeys = Record<string, unknown>, TState = unknown> = Record<
  string,
  | RouteString
  | (RouteObject<TKeys, TState> & {
      thunks: string[];
    })
>;

const createThunk =
  (name: string): RouteThunk<RootState> =>
  (dispatch, getState) => {
    // TODO mmm, thunks code splitting?
    return import(`./${name}`).then(module => {
      const thunk = module.default;

      thunk(dispatch, getState);
    });
  };

export function injectThunks(routesMap: RoutesMapWithLazyThunk): RoutesMap {
  return Object.entries(routesMap).reduce((map, [key, route]) => {
    if (typeof route === "string" || !route.thunks) {
      map[key] = route;
    } else {
      const { thunks, ...otherParams } = route;

      map[key] = {
        ...otherParams,
        thunk: composeThunks(...thunks.map(createThunk)),
      };
    }

    return map;
  }, {});
}
